/** 案件 条件相談：種別 予算 */
export const RFP_NEGOTIATE_TYPE_BUDGET = {
    label: '予算について',
    longLabel: '予算について',
    value: 1,
};
/** 案件 条件相談：種別 PJ開始時期 */
export const RFP_NEGOTIATE_TYPE_START_DATE = {
    label: 'PJ開始時期',
    longLabel: 'プロジェクト開始時期について',
    value: 2,
};
/** 案件 条件相談：種別 PJ終了時期 */
export const RFP_NEGOTIATE_TYPE_END_DATE = {
    label: 'PJ完了時期',
    longLabel: 'プロジェクト完了時期について',
    value: 3,
};
/** 案件 条件相談：種別の一覧 */
export const RFP_NEGOTIATE_TYPES = [
    RFP_NEGOTIATE_TYPE_BUDGET,
    RFP_NEGOTIATE_TYPE_START_DATE,
    RFP_NEGOTIATE_TYPE_END_DATE,
];
